<div class="container dv-invt-mmbr">
  <div class="row">
    <div class="col-xl-6">Edit Permission</div>
    <div class="col-xl-6 db-sbmt-btn">
      <button class="btn-success" *ngIf="IsInvitation"  mat-raised-button cdkFocusInitial (click)="sendInvite()">
        Send
      </button> &nbsp;
      <button class="btn-success" *ngIf="!IsInvitation"  mat-raised-button cdkFocusInitial (click)="submit()">
        Submit
      </button> &nbsp; 
      <button class="btn-danger" mat-stroked-button (click)="closeDialog()">
        Close
      </button>
    </div>
  </div>
  <hr>
  <div class="row">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
          (change)="todoLeafItemSelectionToggle(node)">
          {{node.Permission}}
        </mat-checkbox>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.Permission">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
          <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
            (change)="todoItemSelectionToggle(node)">
            {{node.Permission}}
          </mat-checkbox>
        </div>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>